export const getTenantSettingsEndpoint = (tenantId: string) =>
  `/berths/tenant?tenant_id=${tenantId}` as const
